export enum DocType {
  Paystub = "paystub",
  W2 = "w2",
  BankStatement = "bank_statement"
}
